import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    link: null,
    sidebar: true,
    alertsNum: 0
  },
  mutations: {
    setLink(state, value) {
      state.link = value;
    },
    setSidebar(state, value) {
      state.sidebar = value;
    },
    setAlertsNum(state, value) {
      state.alertsNum = value;
    }
  },
  actions: {

  }
})
